import { Typography } from '@mui/material';

import { ChkAlert, ChkIconWarning } from '@ui/checkout-components';

import { TEST_IDS } from '../../models/globals/testIds.constants';

import type { ErrorAlertProps } from './ErrorAlert.types';

export const ErrorAlert = ({ isVisible, message }: ErrorAlertProps) => {
  if (!isVisible || !message) {
    return null;
  }

  return (
    <ChkAlert
      data-testid={TEST_IDS.SCA_ALERT_BANNER}
      icon={<ChkIconWarning size="sm" />}
      color="error"
    >
      <Typography variant="body3">{message}</Typography>
    </ChkAlert>
  );
};
